import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUser } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const ADDRESS_BOOK_API_URL = BASE_API_URL + 'contact';

/**
 * Local fork of @curbnturf/address-book's AddressBookService — same single
 * endpoint, sourced from cnt-landing's own BASE_API_URL instead of
 * @curbnturf/entities'.
 */
@Injectable({ providedIn: 'root' })
export class AddressBookApiService {
  private readonly http = inject(HttpClient);

  fetch(): Observable<IUser[]> {
    return this.http.get<IUser[]>(ADDRESS_BOOK_API_URL);
  }
}
